export { TabsSection } from "./src/tabs-section";
export type { TabData, TabsSectionProps } from "./src/tabs-section";
